import dynamic from "next/dynamic";
import React, { useState } from "react";
import Video from "./videos";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });

function GridVideos({ videos, activeTag, title }) {
  const [show, setShow] = useState(false);
  const [currentVideo, setCurrentVideo] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const hideModal = () => setShow(null);
  const filterElement = (videos) => {
    // if (activeTag === "All") {
    //   return videos[0].items;
    // } else {
    //   return videos.filter((video) =>
    //     video?.tags?.map((el) => el.toLowerCase()).includes(activeTag)
    //   );
    // }
    //console.log("video",videos);
    return videos ? videos.list : [];
  };

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <h2 className='fs-2 fw-bold lh-1 js-video-category'>{title}</h2>
        </div>
        {/* <ModalVideo channel='youtube' isOpen={show} videoId='DWF2eyTx-4U' onClose={hideModal} /> */}
        <ModalVideo
          channel='youtube'
          youtube={{
            autoplay: 1,
            mute: 1,
          }}
          isOpen={show}
          videoId={currentVideo}
          onClose={hideModal}
          center
        ></ModalVideo>
        {videos?.map((video) => {
          return (
            video?.snippet?.thumbnails?.default && (
              <div className='col-sm-6 col-md-3' key={"v_" + video.id}>
                <Video
                  video={video}
                  onImageClick={() => {
                    // console.log("video_id", video.id);
                    setCurrentVideo(video.snippet.resourceId.videoId);
                    setShow(true);
                  }}
                />
              </div>
            )
          );
        })}{" "}
      </div>
    </>
  );
}

export default GridVideos;
